<template>
  <p>
    VIZBI 2018, the 9<sup>th</sup> international meeting on Visualizing Biological Data, was held
    March 28&ndash;30 at the
    <a href="http://www.broadinstitute.org/">Broad Institute of MIT and Harvard</a>,
    Cambridge MA, USA.
  </p>
  <HeroImage hero-image="Hero.jpg" flyer-hi-res="Poster.pdf" />
  <p>
    VIZBI 2018 featured talks from 21 world-leading researchers showcasing visualizations
    transforming how life scientists view data, and driving key advances in molecular biology,
    systems biology, biomedical science, and ecology.
  </p>
  <p>
    The conference brought together a diverse community, including bioinformaticians, data
    scientists, computer scientists, and experimentalists, as well as medical illustrators,
    graphic designers, and graphic artists.
  </p>
  <p>
    All participants had the opportunity to present a
    <router-link to="Posters">poster and lightning talk</router-link> describing their work.
  </p>
  <p>
    Prior to the meeting (March 27), there was a
    <router-link to="Masterclass">Data Visualization Masterclass</router-link> covering general
    principles, methods, and tools for gaining insight from complex data.
  </p>
  <p>
    As with previous meetings, VIZBI 2018 was an exciting event that helped raise the standard of
    data visualization in the life sciences. Highlights from the meeting are available on the VIZBI
    <router-link to="/blog">blog</router-link>,
    <router-link to="/Posters/2018">posters</router-link>,
    <router-link to="/photos/2018">photos</router-link>, and
    <router-link to="/videos">videos</router-link> pages.
  </p>
  <p>
    To receive updates about VIZBI, you can join the
    <router-link to="/SignUp">VIZBI mailing list</router-link>.
  </p>
</template>

<script setup>
import HeroImage from "@/components/HeroImage.vue";
</script>
